import { TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import MyCustomNumberFormat from "../MyCustomNumberFormat";
import PercentageFormatCustom from "../MyCustomPercentageFormat";

const EasyEditCustomAmountTextbox = ({
    label,
    value,
    name = '',
    currencySymbol,
    currencyCode,
    currencyStringValue,
    setParentValue,
    setAllowEditInline,
    errorMessages
}) => {
    const [selectValue, setSelectValue] = useState(value);

    useEffect(() => {
        if (value === 'N/A') {
            setSelectValue('');
        }
    }, [value]);

    useEffect(() => {
        setAllowEditInline(false); // moved inside useEffect to avoid running on every render
    }, [setAllowEditInline]);

    const handleChange = (event) => {
        const val = event.target.value;
        setParentValue(val);
        setSelectValue(val);
    };

    const getInputComponent = () => {
        if (label === 'Deal Probability') return PercentageFormatCustom;
        return MyCustomNumberFormat;
    };

    const getAdornment = () => {
        if (label === 'Deal Probability') return <span className="text-adornment">%</span>;
        return <span className="text-adornment">{currencyCode}</span>;
    };

    const inputProps = {
        inputComponent: getInputComponent(),
        inputProps: {
            currencySymbol,
            currencyCode,
            currencyStringValue,
            displayType: 'input',
        },
        endAdornment: getAdornment(),
    };

    return (
        <TextField
            variant="filled"
            label={label}
            value={selectValue}
            name={name}
            className="no-margin size-medium control"
            autoFocus
            InputProps={inputProps}
            onChange={handleChange}
            error={!!errorMessages}
            helperText={errorMessages}
        />
    );
};
export default EasyEditCustomAmountTextbox;